var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-grid p-jc-center"},[_c('div',{staticClass:"card p-fluid"},[_c('h5',[_vm._v("Sorry")]),_c('p',[_vm._v("Access to this system is prohibited.")])])])
}]

export { render, staticRenderFns }